import React, { Component, Fragment } from "react";
import _ from "i18n";

import Modal from "react-modal";
import { ICONS, SvgIcon, CrossIcon, SimpleArrowUp } from "../Common/Icons";
import NotFoundV2 from "../NotFound/NotFoundV2";
import ModalEmaillingContent from "./ModalEmaillingContent";
import ModalEmaillingFetching from "./ModalEmaillingFetching";

import styles from "./ModalEmailling.local.scss";

class ModalEmailling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sentModel: null,
      recipientsOptions: [],
      selectedRecipients: [],
      recipientsSelectIsVisible: false
    };
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideRecipientsSelect.bind(this)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { recipients } = this.props;
    if (
      recipients &&
      (prevProps.recipients !== recipients && recipients.length > 0)
    ) {
      let mainAddress = recipients.filter(item => item.main === true);
      let secondAddress = recipients.filter(item => item.main === false);
      this.setState({
        selectedRecipients: mainAddress,
        recipientsOptions: secondAddress
      });
    }
  }

  setRecipientsWrapperRef = node => {
    this.recipientsWrapperRef = node;
  };

  handleClickOutsideRecipientsSelect(event) {
    if (
      this.recipientsWrapperRef &&
      !this.recipientsWrapperRef.contains(event.target)
    ) {
      this.setState({ recipientsSelectIsVisible: false });
    }
  }

  handleRecipientsSelect = recipient => {
    let { selectedRecipients, recipientsOptions } = this.state;
    let newSelectedRecipients = [...selectedRecipients];
    newSelectedRecipients.push(recipient);
    recipientsOptions = recipientsOptions.filter(
      item => recipient.id !== item.id || recipient.email !== item.email
    );
    this.setState({
      recipientsSelectIsVisible: false,
      recipientsOptions,
      selectedRecipients: newSelectedRecipients
    });
  };

  handleSendEmail = (
    recipient,
    modelCode,
    data,
    emails,
    events,
    organization
  ) => {
    this.props.onSendEmail(
      recipient,
      modelCode,
      data,
      emails,
      events,
      organization
    );
    this.setState({ sentModel: modelCode });
  };

  handleDisplayRecipientsSelect = () => {
    this.setState(state => {
      return {
        recipientsSelectIsVisible: !state.recipientsSelectIsVisible
      };
    });
  };

  handleClearSelectedRecipients = () => {
    let { recipients } = this.props;
    this.setState({
      recipientsOptions: recipients,
      selectedRecipients: []
    });
  };

  handleClearSelectedRecipient = recipient => {
    let { selectedRecipients, recipientsOptions } = this.state;
    let newSelectedRecipients = [...selectedRecipients];
    recipientsOptions.push(recipient);
    newSelectedRecipients = newSelectedRecipients.filter(
      item => recipient.id !== item.id || recipient.email !== item.email
    );
    this.setState({
      recipientsSelectIsVisible: false,
      recipientsOptions,
      selectedRecipients: newSelectedRecipients
    });
  };

  handleError = () => {
    const { error } = this.props;

    if (error === 170111) {
      return (
        <NotFoundV2
          errorPageType={"NOTHING_FOUND"}
          text={"recipientsNotFound"}
          redirect={this.props.onRedirectHome}
          buttonText={"addRecipients"}
        />
      );
    } else if (error === 170000) {
      return (
        <NotFoundV2
          errorPageType={"NOTHING_FOUND"}
          text={_("organizationNotFound")}
        />
      );
    } else if (error === 120000) {
      return (
        <NotFoundV2
          errorPageType={"NOTHING_FOUND"}
          text={"emailModelsNotFound"}
          redirect={this.props.onRedirectEmailing}
          buttonText={"addEmailTemplates"}
        />
      );
    } else {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"errorOccured"}
          buttonIgnored={1}
        />
      );
    }
  };
  render() {
    const {
      lng,
      error,
      isClose,
      sending,
      history,
      fetching,
      isVisible,
      recipients,
      modelEmailing
    } = this.props;
    let {
      recipientsOptions,
      selectedRecipients,
      recipientsSelectIsVisible,
      sentModel
    } = this.state;
    return (
      <Modal
        isOpen={isVisible}
        ariaHideApp={false}
        className={{
          base: styles.modalContent,
          afterOpen: styles.modalContentAfterOpen,
          beforeClose: styles.modalContentBeforeClose
        }}
        overlayClassName={styles.modalOverlay}
      >
        <div className={styles.container}>
          <div className={styles.modal_header}>
            <SvgIcon icon={ICONS.SEND} className={styles.modal_icon} />
            <h3 className={styles.modal_title}>{_("choiceModelEmail")}</h3>
          </div>
          {fetching ? <ModalEmaillingFetching /> : ""}
          {error ? (
            this.handleError()
          ) : !fetching ? (
            <Fragment>
              <div className={styles.modal_choice_details}>
                <div className={styles.modal_client_name}>
                  <span>{_("client")}:</span>{" "}
                  <span>
                    {modelEmailing &&
                      modelEmailing.length > 0 &&
                      modelEmailing[0].clientName}
                  </span>
                </div>
                <div>
                  <span>{_("sendToAddress")}:</span>{" "}
                  {recipients && recipients.length > 1 ? (
                    <Fragment>
                      <div
                        ref={this.setRecipientsWrapperRef.bind(this)}
                        className={styles.customed_select}
                        style={{ width: 400 }}
                      >
                        <div className={styles.customed_select_header}>
                          <div className={styles.customed_select_header_tags}>
                            {selectedRecipients.map((item, index) => (
                              <div
                                key={index}
                                className={
                                  styles.customed_select_header_tags_tag
                                }
                              >
                                {`${item.firstName} ${item.lastName}: ${
                                  item.email
                                }`}
                                {item.main && (
                                  <div className={styles.main_tag}>
                                    {_("main")}
                                  </div>
                                )}
                                <div
                                  onClick={() =>
                                    this.handleClearSelectedRecipient(item)
                                  }
                                >
                                  <CrossIcon width={9} color="#0a0a0a" />
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className={styles.customed_select_header_clear}>
                            {selectedRecipients &&
                              selectedRecipients.length > 0 && (
                                <div
                                  onClick={this.handleClearSelectedRecipients}
                                >
                                  <CrossIcon width={9} color="hsl(0,0%,80%)" />
                                </div>
                              )}
                          </div>
                          <div className={styles.actions}>
                            <div>
                              <span
                                className={styles.action}
                                onClick={this.handleDisplayRecipientsSelect}
                              >
                                <SimpleArrowUp />
                              </span>
                            </div>
                          </div>
                        </div>
                        {recipientsSelectIsVisible && (
                          <div className={styles.customed_select_body}>
                            <div
                              className={styles.customed_select_body_options}
                            >
                              {recipientsOptions.length > 0 ? (
                                recipientsOptions.map((item, index) => (
                                  <div
                                    key={index}
                                    className={
                                      styles.customed_select_body_option
                                    }
                                    onClick={() =>
                                      this.handleRecipientsSelect(item)
                                    }
                                  >
                                    {`${item.firstName} ${item.lastName}: ${
                                      item.email
                                    }`}
                                    {item.main && (
                                      <div className={styles.main_tag}>
                                        {_("main")}
                                      </div>
                                    )}
                                  </div>
                                ))
                              ) : (
                                <div
                                  className={
                                    styles.customed_select_body_no_option
                                  }
                                >
                                  {_("noOptions")}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </Fragment>
                  ) : (
                    `(${recipients &&
                      recipients.length &&
                      recipients[0].email})`
                  )}
                </div>
              </div>
              <hr />
              <div className={styles.modal_emailing}>
                {modelEmailing.map((item, i) => {
                  return (
                    <ModalEmaillingContent
                      model={item}
                      index={i}
                      lng={lng}
                      history={history[item.modelCode]}
                      sending={sending}
                      recipients={selectedRecipients}
                      sentModel={sentModel}
                      organization={
                        modelEmailing.length && modelEmailing[0].clientName
                      }
                      onSendEmail={this.handleSendEmail}
                    />
                  );
                })}
              </div>
            </Fragment>
          ) : (
            ""
          )}
        </div>
        <div className={styles.modal_close} onClick={isClose}>
          <img src="/img/icons/close.svg" alt={""} />
        </div>
      </Modal>
    );
  }
}

export default ModalEmailling;



// WEBPACK FOOTER //
// ./src/components/FicheClient/ModalEmailling.js